import React, { useEffect, useState, useContext } from "react";
import { PageProps } from "gatsby";
import { login, isLoggedIn, getProfile, saveCurrentPortalRoute } from "./auth";
import { ClientUsersClient } from "@api";
import { Loading } from "lib";
import { showError } from "@action";
import { navigate } from "gatsby";
import { Store } from "@store";

const PrivateRoute = ({ children, path, location }: PageProps) => {
  const pathForPortalSave =
    location?.pathname ||
    (typeof window !== "undefined" ? window.location.pathname : path) ||
    path;
  const isPortalRoute =
    pathForPortalSave.includes("/course") ||
    pathForPortalSave.includes("/assessment");
  const isAuth = isLoggedIn(path);
  const { setLang, setClientUserInfo } = useContext(Store);

  if (!isAuth) {
    if (isPortalRoute) {
      saveCurrentPortalRoute(pathForPortalSave);
      login(pathForPortalSave);
    } else {
      login(path);
    }
    return <Loading />;
  }

  if (isPortalRoute) {
    saveCurrentPortalRoute(pathForPortalSave);
  }

  const [isLoading, setIsLoading] = useState(true);

  const needCheckUser = ![
    "/logout-callback/",
    "/login-callback/",
    "/silent-callback/",
    "/welcome/",
    "/register/:passphrase",
  ].includes(path);

  useEffect(() => {
    const checkRedirectPage = async () => {
      const user = getProfile();
      const client = new ClientUsersClient();
      const result = await client.getCurrentClientUser().catch((err) => {
        showError(err);
        return null;
      });
      const needChangePassword =
        !result?.haveChangePassword && result?.clientGroupCanCustomizePassword;
      const needEnterDetail =
        !result?.haveEnterDetail &&
        (result?.clientGroupCanCustomizeFullName ||
          result?.clientGroupCanCustomizeEmail ||
          result?.clientGroupCanCustomizePreferredLanguage);

      const hasStoredLang = !!sessionStorage.getItem("lang");
      if (!hasStoredLang) {
        setLang(user.PreferredLanguageId || "en");
      }

      setClientUserInfo(result);

      if (needChangePassword || needEnterDetail) {
        navigate("/welcome/", {
          replace: true,
          state: {
            redirectUrl: path,
          },
        });
      } else {
        setIsLoading(false);
      }
    };

    if (isAuth && needCheckUser) checkRedirectPage();
  }, []);

  return isLoading && needCheckUser ? <Loading /> : children;
};

export default PrivateRoute;
